import { differenceInCalendarDays as a } from "./differenceInCalendarDays.js";
import { startOfYear as f } from "./startOfYear.js";
import { toDate as e } from "./toDate.js";
function s(t) {
  const r = e(t);
  return a(r, f(r)) + 1;
}
export {
  s as default,
  s as getDayOfYear
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getDayOfYear.js
// module id = 1342
// module chunks = 41